import { createContext, useState } from "react";

export const UnseContext = createContext();

export function UnseProvider({ children }) {
    const [unseData, setUnseData] = useState(null);

    return (
        <UnseContext.Provider value={{ unseData, setUnseData }}>
            {children}
        </UnseContext.Provider>
    );
}
